import type { ProspectListEntry } from "../../../api/client.ts";

/** An entry's state on its collection: accepted, disqualified, or neither yet. */
export type ProspectStatus = "pending" | "accepted" | "disqualified";

/** Works for both company entries and contact entries — they share the columns. */
export function getProspectStatus(p: {
  disqualified_at: string | null;
  accepted_at: string | null;
}): ProspectStatus {
  if (p.disqualified_at) return "disqualified";
  if (p.accepted_at) return "accepted";
  return "pending";
}

/**
 * What the collection's company dialogs and panels need of an entry: its id,
 * the company it is (or none, unresolved) and the snapshot that names it.
 */
export type CollectionCompany = Pick<
  ProspectListEntry,
  | "id"
  | "master_company_id"
  | "company_name"
  | "company_country"
  | "company_domain"
  | "company_org_number"
  | "company_website"
>;

/** Key of an entry's company in the contacts / purchases maps: the company, or
 * the entry itself for a company the database does not hold. */
export function companyKey(p: Pick<ProspectListEntry, "id" | "master_company_id">): string {
  return p.master_company_id ?? `entry:${p.id}`;
}
